/* Fil d'Ariane de RANGEMENT, avec la COLLECTION D'ENTREE conservee.
   Le POURQUOI complet est dans _tools/chemin_trajet.py ; ce fichier n'en
   garde que ce qu'il faut pour le relire sans se tromper.

   Le fil dit OU LA PAGE EST RANGEE, jamais par ou le client est passe. Une
   seule chose est retenue de sa navigation : la DERNIERE collection (listing)
   traversee. Elle remplace le rangement d'origine du produit, et c'est tout.

     accueil > section Best-sellers > fiche   Accueil > Best-sellers > Cloudboom Volt
     /femme/ > /femme/running/ > fiche        Decouvrir > Femme > Running > Cloudboom Volt
     arrivee directe sur la fiche             son rangement d'origine

   Le deuxieme exemple montre le point important : ce n'est pas la derniere
   PAGE visitee qui entre dans le fil, c'est le RANGEMENT COMPLET de la
   collection d'entree -- « Decouvrir > Femme > Running », le fil de
   /femme/running/ lui-meme. Rien n'a donc besoin d'etre empile : une seule
   collection en memoire suffit, et le fil ne peut pas s'allonger sans fin.

   UN PRODUIT EST UNE FEUILLE. Une fiche n'ecrit JAMAIS dans la memoire de
   collection. C'est ce qui rend impossible le defaut qui a motive cette
   reecriture : un fil qui enfilait des fiches produit les unes derriere les
   autres (« Cloudmonster 3 > Cloudrunner 3 > Cloudboom Volt »). Passer d'une
   fiche a une autre par un bloc « A voir aussi » garde la collection d'entree,
   exactement comme sur un vrai site marchand.

   OU EST LA MEMOIRE. En sessionStorage : elle appartient a une VISITE, pas a
   la machine. Un onglet neuf, un lien partage, un retour le lendemain
   retombent sur le fil ecrit dans le HTML -- celui du rangement -- et jamais
   sur une collection fantome. L'accueil la remet a zero : une visite qui
   revient au point de depart repart d'un chemin neuf.

   L'ACCUEIL N'EST PAS UNE COLLECTION mais il en montre une : sa section
   « Best-sellers » mene directement a des fiches sans passer par
   /best-sellers/. Le conteneur de cette section porte donc un attribut
   data-fil (pose par le script python) et un clic delegue le lit. L'attribut
   est sur le CONTENEUR et jamais sur les cartes : format_cartes.py les
   reconstruit et l'effacerait sans un mot.

   LE CLIGNOTEMENT. Le fil du HTML est deja rendu ; le reecrire au chargement
   complet le ferait sauter sous les yeux. Ce script est donc BLOQUANT dans le
   <head>, calcule tout avant que le <body> n'existe, et reecrit chaque <nav> a
   l'instant meme ou l'analyseur le pose, via un MutationObserver.
   DOMContentLoaded n'est qu'un filet de securite.

   Chaque maillon reste un vrai lien : les adresses viennent du fil ecrit a la
   construction, aucune n'est fabriquee ici, donc aucune ne peut etre morte. Le
   dernier maillon est toujours la page courante, avec aria-current="page". */
(function () {
  'use strict';

  var CLE = 'on:collection';
  var SELECTEUR = '.hdr-crumbs, .crumbs--plp, .pdp-crumbs';
  /* Une collection n'a aucune raison de compter dix niveaux ; au-dela c'est
     une memoire corrompue, pas un fil. */
  var MAX = 6;

  function chemin(u) {
    var p;
    try {
      p = new URL(u, location.href).pathname;
    } catch (e) {
      return '';
    }
    /* La requete (?c=coloris, ?modele=...) est un etat, pas un lieu. */
    p = p.replace(/index\.html$/, '');
    return p || '/';
  }

  /* Une liste de miettes, et rien d'autre : chaque entree doit porter une
     etiquette (l) et une adresse (u) du site qui commence par « / ». Le reste
     est jete. */
  function liste(brut) {
    var t, i, propre;
    if (!brut) { return []; }
    try {
      t = JSON.parse(brut);
    } catch (e) {
      return [];
    }
    if (Object.prototype.toString.call(t) !== '[object Array]') { return []; }
    propre = [];
    for (i = 0; i < t.length && propre.length < MAX; i += 1) {
      if (t[i] && typeof t[i].u === 'string' && typeof t[i].l === 'string'
          && t[i].l && t[i].u.charAt(0) === '/' && t[i].u.indexOf('//') !== 0) {
        propre.push({ u: t[i].u, l: t[i].l });
      }
    }
    return propre;
  }

  /* Une COLLECTION : une liste de miettes dont aucune ne designe une fiche
     produit. C'est la garde qui rend impossible le defaut d'origine -- un
     produit devenu miette intermediaire -- meme si sessionStorage a ete
     bricole a la main ou si un data-fil est mal pose. */
  function miettes(brut) {
    var t = liste(brut);
    var i;
    for (i = 0; i < t.length; i += 1) {
      if (t[i].u.indexOf('/products/') === 0) { return []; }
    }
    return t;
  }

  function lire() {
    try {
      return miettes(sessionStorage.getItem(CLE));
    } catch (e) {
      return [];
    }
  }

  function ecrire(t) {
    try {
      sessionStorage.setItem(CLE, JSON.stringify(t));
    } catch (e) {
      /* navigation privee, quota, cookies refuses : le fil du HTML reste. */
    }
  }

  function oublier() {
    try {
      sessionStorage.removeItem(CLE);
    } catch (e) {}
  }

  var ici = chemin(location.pathname);
  var fiche = ici.indexOf('/products/') === 0;

  /* Le rangement de CETTE page, calcule a la construction et non devine ici :
     le <h1> et la miette ne disent pas la meme chose (« Running femme » contre
     « Running »), et le navigateur n'a pas a arbitrer. Pas de meta = page non
     identifiee = on ne touche a rien. */
  var meta = document.querySelector('meta[name="fil-ariane"]');
  var rangement = liste(meta ? meta.getAttribute('content') : '');
  /* La DERNIERE miette du rangement designe toujours la page courante -- c'est
     verifie a la construction. Sur une fiche c'est la seule miette qui ait le
     droit de nommer un produit. */
  var moi = rangement.length ? rangement[rangement.length - 1] : null;

  var affiche = [];

  function calculer() {
    affiche = [];
    if (ici === '/') {
      /* Le point de depart d'une visite : la collection precedente n'a plus
         cours. Sans cette remise a zero, un client qui remonte au logo puis
         entre dans un produit par une autre porte se verrait annoncer la
         collection qu'il a quittee. */
      oublier();
      return;
    }
    if (!moi) { return; }

    if (!fiche) {
      /* Un listing EST une collection : il se retient lui-meme, avec son
         rangement complet. Son propre fil reste celui du HTML. */
      if (miettes(meta.getAttribute('content')).length) { ecrire(rangement); }
      return;
    }

    var col = lire();
    if (!col.length) { return; }          /* arrivee directe : rangement d'origine */
    affiche = col.concat([moi]);
  }

  function memeQueLeHtml(nav) {
    /* Quand la collection d'entree EST le rangement du produit, le fil
       calcule et le fil ecrit disent la meme chose : on ne touche a rien
       plutot que de reconstruire a l'identique. */
    var liens = nav.getElementsByTagName('a');
    var i;
    if (liens.length !== affiche.length) { return false; }
    for (i = 0; i < liens.length; i += 1) {
      if (chemin(liens[i].getAttribute('href') || '') !== chemin(affiche[i].u)) {
        return false;
      }
    }
    return true;
  }

  function rendre(nav) {
    var sep = '›';
    var s, i, a, e, frag;
    if (nav.filOrigine === undefined) { nav.filOrigine = nav.innerHTML; }
    /* Plus de collection en memoire (retour a l'accueil, puis retour arriere
       sur cette fiche) : le fil du HTML -- le rangement -- reprend sa place. */
    if (affiche.length < 2) {
      if (nav.innerHTML !== nav.filOrigine) { nav.innerHTML = nav.filOrigine; }
      return;
    }
    if (memeQueLeHtml(nav)) { return; }
    /* Le separateur est celui de la page : « › » sur les fiches, « > » sur
       les listings. On reprend le sien pour ne rien changer a l'oeil. */
    s = nav.querySelector('span');
    if (s && s.textContent.trim()) { sep = s.textContent.trim(); }

    frag = document.createDocumentFragment();
    for (i = 0; i < affiche.length; i += 1) {
      if (i) {
        e = document.createElement('span');
        e.textContent = sep;
        frag.appendChild(e);
      }
      a = document.createElement('a');
      a.setAttribute('href', affiche[i].u);
      /* textContent, jamais innerHTML : une etiquette est du texte. */
      a.textContent = affiche[i].l;
      if (i === affiche.length - 1) { a.setAttribute('aria-current', 'page'); }
      frag.appendChild(a);
    }
    nav.innerHTML = '';
    nav.appendChild(frag);
    caler(nav);
  }

  /* Sous 1000px le fil de l'en-tete tient sur une ligne etroite : a quatre
     miettes il deborde, et le CSS le laisse glisser plutot que de le couper.
     On le cale sur sa FIN -- la page courante -- pour que le client lise
     toujours ou il est ; le debut du chemin est a un glissement de pouce. */
  function caler(nav) {
    if (nav.scrollWidth > nav.clientWidth) { nav.scrollLeft = nav.scrollWidth; }
  }

  function recaler() {
    var navs = document.querySelectorAll(SELECTEUR);
    var i;
    for (i = 0; i < navs.length; i += 1) { caler(navs[i]); }
  }

  var fini = false;

  function balayer() {
    var navs = document.querySelectorAll(SELECTEUR);
    var i, nav;
    for (i = 0; i < navs.length; i += 1) {
      nav = navs[i];
      if (nav.filFait) { continue; }
      nav.filFait = true;
      rendre(nav);
      /* .hdr-crumbs est la copie de l'en-tete, posee AVANT le fil de la page.
         Le fil de la page ferme donc la marche : une fois pose, plus rien a
         attendre et l'observateur peut lacher le document. */
      if (nav.className.indexOf('hdr-crumbs') === -1) { fini = true; }
    }
    return fini;
  }

  calculer();
  if (affiche.length >= 2 && !balayer()) {
    var obs = new MutationObserver(function () {
      if (balayer() && obs) {
        obs.disconnect();
        obs = null;
      }
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('DOMContentLoaded', function () {
      balayer();
      if (obs) {
        obs.disconnect();
        obs = null;
      }
    });
  }

  /* La section « Best-sellers » de l'accueil mene a des fiches sans passer par
     /best-sellers/ : une page d'accueil n'est pas une collection, mais elle en
     montre une. Le conteneur de la section porte data-fil (le rangement de la
     collection, pose a la construction) et le clic le retient. Delegation sur
     le document : les cartes sont reconstruites par format_cartes.py, aucun
     ecouteur ne doit dependre d'elles. */
  document.addEventListener('click', function (ev) {
    var cible = ev.target;
    var lien, bloc, f;
    if (!cible || !cible.closest) { return; }
    lien = cible.closest('a[href]');
    if (!lien) { return; }
    if (chemin(lien.getAttribute('href')).indexOf('/products/') !== 0) { return; }
    bloc = lien.closest('[data-fil]');
    if (!bloc) { return; }
    f = miettes(bloc.getAttribute('data-fil'));
    if (f.length) { ecrire(f); }
  }, true);

  /* La police 'On Mono' arrive apres le premier rendu et change la largeur du
     fil : ce qui etait cale sur la fin ne l'est plus. On recale a la fin du
     chargement, et au changement de largeur d'ecran. */
  window.addEventListener('load', recaler);
  window.addEventListener('resize', recaler);
  if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
    document.fonts.ready.then(recaler);
  }

  /* Retour arriere servi par le cache de navigation : la page est restituee
     telle quelle, ce script ne rejoue pas. Sans ce rattrapage, un listing
     revisite en arriere ne se remettrait pas en memoire et la fiche suivante
     annoncerait la collection d'un autre rayon. */
  window.addEventListener('pageshow', function (ev) {
    if (!ev.persisted) { return; }
    calculer();
    var navs = document.querySelectorAll(SELECTEUR);
    var i;
    for (i = 0; i < navs.length; i += 1) { rendre(navs[i]); }
  });
}());
